import Accordion from './Accordion/Accordion';
import AnimatedProgressProvider from './Animation/AnimatedProgressProvider';

import CardAuthor from './CardElements/CardAuthor';
import CardCategory from './CardElements/CardCategory';
import CardDescription from './CardElements/CardDescription';
import CardIcon from './CardElements/CardIcon';
import CardSocial from './CardElements/CardSocial';
import CardSocials from './CardElements/CardSocials';
import CardStats from './CardElements/CardStats';

import Button from './CustomButton/CustomButton';

import IconCheckbox from './CustomCheckbox/IconCheckbox';
import Checkbox from './CustomCheckbox/SimpleCheckbox';

import Progress from './CustomProgress/CustomProgress';

import Radio from './CustomRadio/CustomRadio';

import ImageUpload from './CustomUpload/ImageUpload';
import PictureUpload from './CustomUpload/PictureUpload';

import Footer from './Footer/Footer';

import FormInputs from './FormInputs/FormInputs';

import Header from './Header/Header';
import PagesHeader from './Header/PagesHeader';

import InfoArea from './InfoArea/InfoArea';

import Instructions from './Instructions/Instructions';

import PanelHeader from './PanelHeader/PanelHeader';

import Sidebar from './Sidebar/Sidebar';

import Statistics from './Statistics/Statistics';

import Stats from './Stats/Stats';

import Tasks from './Tasks/Tasks';

import Timeline from './Timeline/Timeline';

import Technician from './Technician/Technician';

import BillsTable from './Bills/BillsTable';

export {
    // Accordion
    Accordion,
    AnimatedProgressProvider,
    // CardElements
    CardAuthor,
    CardCategory,
    CardDescription,
    CardIcon,
    CardSocial,
    CardSocials,
    CardStats,
    // CustomButton
    Button,
    // CustomCheckbox
    IconCheckbox,
    Checkbox,
    // CustomProgress
    Progress,
    // CustomRadio
    Radio,
    // CustomUpload
    ImageUpload,
    PictureUpload,
    // Footer
    Footer,
    // FormInputs
    FormInputs,
    // Header
    Header,
    PagesHeader,
    // InfoArea
    InfoArea,
    // Instructions
    Instructions,
    // PanelHeader
    PanelHeader,
    // Sidebar
    Sidebar,
    // Statistics
    Statistics,
    // Stats
    Stats,
    // Tasks
    Tasks,
    // Timeline
    Timeline,
    // Technician
    Technician,
    // Bills Table,
    BillsTable
};



// WEBPACK FOOTER //
// ./src/components/index.js